module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_TOC_Heading",
    attrs: {
      "id": "tableofcontents"
    }
  }, [_c('span', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0001#a__Toc448782306"
    }
  }, [_vm._v("Book Description")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0002#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0004#a__Toc448782307"
    }
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0005#auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0006#a__Toc448782310"
    }
  }, [_vm._v("Sisters")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0007#a__Toc448782312"
    }
  }, [_vm._v("Sankofa")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0008#a__Toc448782314",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Prince of Artemis V")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0009#a__Toc448782316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aftermaths")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0010#a__Toc448782318",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Driving a Bargain")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0011#a__Toc448782320",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Father’s Eyes")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0012#a__Toc448782322",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Like a Thief in the Light")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0013#a__Toc448782324",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clockwork Fagin")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0014#a__Toc448782326",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Postcards")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0015#a__Toc448782328",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Outbreeders")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0016#a__Toc448782330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rivalry on the Sky Course")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0017#a__Toc448782332",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Echo in the Shell")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0018#a__Toc448782334",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Milky Way Dance Hall")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0019#a__Toc448782336",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blood and Water")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0020#a__Toc448782338",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Boy Who Yelled “Dragon”")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0021#a__Toc448782340",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Newts")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0022#a__Toc448782342",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Babydoll")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0023#a__Toc448782344",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shade")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0024#a__Toc448782346",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Granted")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0025#a__Toc448782348",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The War of Gifts")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0026#Copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notices")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0027#a__Toc448782351",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Editor")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0028#a__Toc448782352",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("If You Liked …")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/section0029#a__Toc448782353",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other WordFire Press Titles by Bryan Thomas Schmidt")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bd1666","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 66
// module chunks = 0